import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'cmv-generic-content',
	templateUrl: './generic-content.component.html',
	styleUrls: ['./generic-content.component.scss'],
})
export class GenericContentComponent {
	@Input()
	contentTitle: string;
	@Input()
	btnText: string;
	@Output() clickEvent: EventEmitter<void> = new EventEmitter();

	constructor() {}

	onClick(): void {
		this.clickEvent.emit();
	}
}
